export default __webpack_public_path__ + "static/media/zoomin.15faa8e2.cur";